import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import * as Sentry from '@sentry/browser'
import { tap } from 'rxjs/operators';

class SentryHttpError extends Error {
  public name;

  constructor(httpError: HttpErrorResponse) {
    const message = `URL: ${httpError.url} Description: ${httpError.message} Error ${JSON.stringify(httpError.error)}`;
    super(message);
    this.name = `HTTP:${httpError.status}`;
    Object.setPrototypeOf(this, new.target.prototype);
  }

}

@Injectable()
export class HttpErrorLoggingInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {}, (error: any) => {
        if (error instanceof HttpErrorResponse) {
          // From online research, investigation into sentry logs, and experimentation
          // it seems that the most likely cause of an HttpErrorResponse with status 0
          // is bad network conditions i.e a temporary network dip
          // or a firewall blocking certain requests.
          const errorLikelyCausedByBadNetworkConditions = error.status === 0;
          const errorCausedByUnauthorisedUser = error.status === 401;
          if (!errorCausedByUnauthorisedUser && !errorLikelyCausedByBadNetworkConditions) {
            // Only report errors that are:
            // 1. Caused by users that are authorised
            // 2. Caused by something other than bad network conditions
            const sentryHttpError = new SentryHttpError(error);
            // TODO: Decide on how to action these errors before logging (it's flooding Sentry and we're not actioning it)
            // Sentry.captureException(sentryHttpError);
          }
        }
      })
    );
  }

}
